import { ReactNode, useContext, useEffect } from "react"
import { MediaMobile, MediaTablet } from "../../../api/const/MediaQuery"
import useMediaQuery from "../../../hook/useMediaQuery"
import { CompanyLeftSection } from "../../molecules"
import image from "../../../img/professional-businessman.png";
import clsx from "clsx";
import { StartUpStepperContext } from "../../pagine/getStarted/stepper/startUp/StartUpStepperContext";

type StepperTemplateProps = {
    children: ReactNode
}

export const StepperTemplate = ({ children }: StepperTemplateProps) => {
    const tablet = useMediaQuery(MediaTablet)
    const mobile = useMediaQuery(MediaMobile)
    const ctx = useContext(StartUpStepperContext)

    useEffect(() => {
        
    }, [])

    return (
        <div className={clsx(" p-0 get-started-container m-0 w-100  ")} >
            <div className=" w-100 h-100 m-0  d-flex flex-row p-0 ">
                {/* LEFT SECTION */}
                {!tablet &&
                    <div className="w-100 h-100 m-0 p-0 border-right left-section ">
                        <CompanyLeftSection
                            title={"Join in  Innovation Match, where innovation takes place"}
                            image={image}
                        />
                    </div>
                }
                {/* RIGHT SECTION */}
                <div className={clsx("w-100 h-100  right-section    p-0  ps-3  m-0  ",
                    )}>
                    
                        {children} 
                    
                </div>
            </div>
        </div>
    )
}